import React from "react";
import { TextField } from "@mui/material";
import {
  Controller,
  FieldError,
  FieldErrorsImpl,
  Merge,
} from "react-hook-form";

interface InputFieldRegProps {
  fieldName: string;
  label: string;
  fullWidth?: boolean;
  control: any;
  error?: boolean;
  helperText?:
    | string
    | null
    | undefined
    | FieldError
    | Merge<FieldError, FieldErrorsImpl<any>>;
  defaultValue?: string | null;
  onBlur?: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  other?: any;
  multiline?: boolean | undefined;
  isDisable?: boolean;
  isTextGrey?: boolean;
  style?: object;
}

const InputFieldReg: React.FC<InputFieldRegProps> = ({
  fieldName,
  control,
  label,
  error,
  helperText,
  fullWidth,
  defaultValue,
  onBlur,
  other,
  multiline,
  isDisable = false,
  isTextGrey = true,
  style = {},
}) => {
  return (
    <Controller
      name={fieldName}
      control={control}
      defaultValue={defaultValue || ""}
      render={({ field }) => (
        <TextField
          {...field}
          multiline={multiline}
          size="small"
          variant={isTextGrey ? "outlined" : "standard"}
          rows={multiline ? 10 : 1}
          label={label}
          fullWidth={fullWidth || true}
          error={error}
          helperText={helperText || ""}
          onBlur={(
            event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
          ) => {
            field.onBlur();
            onBlur && onBlur(event);
          }}
          disabled={isDisable}
          InputProps={{
            sx: {
              backgroundColor: "#f2f4fb",
              "& input": {
                pointerEvents: isTextGrey ? "auto" : "none",
              },
              "& fieldset": {
                borderColor: "#eaf1f9",
              },
            },
          }}
          style={style}
          {...other}
        />
      )}
    />
  );
};

export default InputFieldReg;
